import { useQuery, queryKeyFactory } from '@/services/store';
import { ServiceError } from '@/services/api';
import { IPublicWebsite } from '@/entities';
import { getPublicWebsite } from '../api';

interface IUseGetPublicWebsiteProps {
  userId?: string;
}

export const useGetPublicWebsite = ({ userId }: IUseGetPublicWebsiteProps) => {
  const enabled = !!userId;
  return useQuery<IPublicWebsite, ServiceError>({
    queryKey: enabled ? queryKeyFactory.publicWebsite(userId) : undefined,
    queryFn: async () => {
      if (!enabled) {
        throw new Error('userId is missing');
      }
      const data = await getPublicWebsite({ params: { userId } });
      return data;
    },
    enabled,
  });
};
